import { Container, Col, Row } from "reactstrap";
import { dayLabel } from "components/day/dates";
import { BreadcrumbItem } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as EntryQL from "queries/entry";
import { Component as Form } from "@repoflow/form-schema";
import { MEALS } from "@common/schema/entry/fields";
import { Mutation, Button } from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Add food</BreadcrumbItem>;

// The field list, hoisted out of the component: a `config` literal in JSX is a
// new object every render, and the form rebuilds its widget tree under a new
// one — see wfws' workflow editor for what that costs a field being typed in.
//
// `date` is not asked for. The day screen this was opened from IS the date, and
// a second place to choose it would be a second place to get it wrong.
const FIELDS = {
  "/Public/Entry/Create": {
    fields: [
      { property: "food" },
      { property: "serving", description: "Free text — \"1 cup\", \"200 g\", \"2 slices\"." },
      { property: "meal" },
      { property: "calories" },
      { property: "protein" },
      { property: "carbs" },
      { property: "fat" },
    ],
  },
};

// The meal a person most likely means, when the link did not say: the one the
// clock is nearest to. Only a default — the field is right there.
export const mealForHour = (hour) => {
  if (hour < 11) return "breakfast";
  if (hour < 16) return "lunch";
  if (hour < 21) return "dinner";
  return "snack";
};

export const Content = ({ match: { params: { date } } }) => {
  const history = useHistory();
  const { search } = useLocation();
  const asked = new URLSearchParams(search).get("meal");

  const initial = {
    date,
    meal: MEALS.includes(asked) ? asked : mealForHour(new Date().getHours()),
    food: "",
    serving: "",
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Entry/Create" }}
      mutation={EntryQL.create}
      update={EntryQL.update()}
      onMutate={({ state: { values }, handler }) => {
        handler({ variables: { input: { ...values, date } } });
      }}
      onCompleted={() => {
        // replace(), not push(): Back from the day should not reopen a form for
        // something already logged.
        history.replace(`/day/${date}`);
      }}
      onError={(error) => {
        Notify.error(String(error));
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

// The Mutation hands its children the section context — `schema`, `state`,
// `mutate`, `target` — and NOT a Fields component. The form is built here from
// those, which is the shape every other screen in this app uses.
const MutationHandler = ({ schema, state, mutate, target }) => {
  const { values, setValues } = state;

  return (
    <Container className="mt-4" style={{ maxWidth: 760 }}>
      {/* Which day this lands on, said once, since the form has no date field. */}
      <h4 className="mb-4">Add food to {dayLabel(values.date).replace(/^(Today|Yesterday|Tomorrow)$/, (d) => d.toLowerCase())}</h4>
      <Row>
        <Col>
          <Form
            schema={schema}
            target={target}
            values={values}
            widgets={appWidgets}
            config={FIELDS}
            onSubmit={() => mutate()}
            onChange={(vals) => setValues(vals)}
          >
            <Button type="submit">Add</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
